export default __webpack_public_path__ + "static/media/grafema_angura_02.ea6f0b89.mp4";